import React from 'react';

import type { IconProps } from '~/components/icons/types';

import SvgIcon from '../core/SvgIcon';

const ChevronUpIcon: React.FC<IconProps> = ({ iconColor, size = 24, ...props }) => (
  <SvgIcon viewBox="0 0 20 20" fill="none" size={size} {...props}>
    <path
      d="M3.75 12.5L10 6.25L16.25 12.5"
      stroke={iconColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default ChevronUpIcon;
